import { Dialog } from "@mui/material"
import type { FC } from "react"

import type { ConfirmationTemplateProps } from "@/components/common/Modals"
import { ConfirmationTemplate } from "@/components/common/Modals"

type ConfirmationDialogProps = ConfirmationTemplateProps

const ConfirmationDialog: FC<ConfirmationDialogProps> = (props) => {
  const { onClose } = props

  return (
    <Dialog data-testid='confirmation-dialog' open={true} onClose={onClose} maxWidth='sm' fullWidth>
      <ConfirmationTemplate {...props} />
    </Dialog>
  )
}

export default ConfirmationDialog
